import { useState } from 'react';
import { INITIAL_TABS_ARRAY, TABS } from '../constants';
import { ActiveTabs, UseTabsServiceType } from '../types';

const useTabsService = (): UseTabsServiceType => {
  const [activeTab, setActiveTab] = useState<number>(TABS.ADD_MEMBER);
  const [activeTabsArray, setActiveTabsArray] =
    useState<ActiveTabs>(INITIAL_TABS_ARRAY);

  const handleChange = (newValue: number) => {
    if (activeTabsArray[newValue]) {
      setActiveTab(newValue);
    }
  };

  const goToActiveTab = (tab: number) => {
    setActiveTab(tab);
  };

  return {
    activeTab,
    activeTabsArray,
    handleChange,
    setActiveTabsArray,
    goToActiveTab,
  };
};

export default useTabsService;
